// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pet-tag-img[data-v-fa06bd7e]{max-height:180px;width:auto}", ""]);
// Exports
module.exports = exports;
